import { fetchdata } from 'apis/FetchData';
import { handle420 } from 'apis/HandleError';
import { apiConfig } from 'config';

export const getLatestHeatmapFromDevice = (deviceId, abortController) => {
  const url = apiConfig.cmServiceRetrieveLatestHeatmapFromDevice(deviceId);
  return fetchdata(url, { method: 'GET' }, true, abortController.current)
    .then((result) => result)
    .catch((e) => {
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          throw e;
      }
    });
};
